<div class="dialog-panel dialog-post">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }

    <div class="dialog-header">
      <h1 class="dialog-title dot">{{ 'planning.plan_post' | transloco }}</h1>
    </div>

    @if (formDraftPost) {
      <form [formGroup]="formDraftPost" class="form-draft-post" (submit)="onSubmit()">
        <div class="row">
          <div class="col-12 form-field-container" [class.chip-list-empty]="!selectedShops.length">
            <div class="form-field-label">
              {{ 'form.field.upload_media' | transloco }}
            </div>
            <div class="d-flex">
              <div class="w-100">
                <lib-drag-drop-photos
                  [maxImgRes]="4000"
                  [maxFileSize]="20"
                  [items]="getFormControl('media').value ? getFormControl('media').value : []"
                  (filesChange)="updateFormWithImages($event)"
                >
                </lib-drag-drop-photos>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-field-container chip-list-form-field" [class.chip-list-empty]="!selectedShops.length">
            <div class="form-field-label required">
              {{ 'form.field.choose_shop' | transloco }}
            </div>
            @if (shops.length) {
              <mat-form-field class="form-field" [floatLabel]="'auto'">
                <mat-select
                  (selectionChange)="addShop($event.value)"
                  [value]="selectedShops[0]"
                  panelClass="draft-shop-shop-select"
                >
                  <mat-select-trigger>
                    <mat-chip-grid>
                      @for (shop of selectedShops; track shop) {
                        <mat-chip-row [removable]="true" (removed)="removeShop(shop)">
                          <span>{{ shop.name }}</span>
                          <span matChipRemove class="icon-remove" [inlineSVG]="'/icons/icon-close.svg'"></span>
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                  </mat-select-trigger>
                  @for (shop of shops; track shop) {
                    <mat-option [value]="shop">
                      <span>{{ shop.name }}</span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (selectedShops && !selectedShops.length) {
              <mat-error>
                <ng-container>
                  {{ 'form.error.required' | transloco }}
                </ng-container>
              </mat-error>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-field-container">
            <div class="form-field-label required">
              {{ 'form.field.post_title' | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <input matInput [formControlName]="'title'" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-field-container">
            <div class="form-field-label">
              {{ 'form.field.description' | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <textarea
                matInput
                [formControlName]="'body'"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="10"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="form-field-container chip-list-form-field col-12" [class.chip-list-empty]="!getHashtags().length">
            <div class="form-field-label">
              {{ 'form.field.add_hashtags' | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <mat-chip-grid #hashtagList>
                @for (hashtag of getHashtags(); track hashtag) {
                  <mat-chip-row [removable]="true" (removed)="removeHashtag(hashtag)">
                    <span>{{ hashtag }}</span>
                    <span matChipRemove class="icon-remove" [inlineSVG]="'/icons/icon-close.svg'"></span>
                  </mat-chip-row>
                }
                <input
                  [matChipInputFor]="hashtagList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="false"
                  (matChipInputTokenEnd)="addHashtag($event)"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-field-container col-md-5">
            <div class="form-field-label">
              {{ 'form.field.start_date' | transloco }}
            </div>
            <lib-date-time-field [formControlName]="'planned'" [min]="minDate">
              @if (formDraftPost.get('planned').invalid) {
                <mat-error>
                  @if (formDraftPost.get('planned').errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                </mat-error>
              }
              @if (formDraftPost.get('planned').errors?.dateTimeMin ? true : false) {
                <div class="mat-error">
                  {{ 'form.error.min_date_24_from_now' | transloco }}
                </div>
              }
            </lib-date-time-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-field-container">
            <div class="form-field-label required">
              {{ 'form.field.select_platform' | transloco }}
            </div>
            <div class="socials-container row">
              @for (platform of platforms; track platform) {
                <div class="col-12 social-platform justify-content-between">
                  <div class="social-info">
                    <img class="social-img" [lazyLoad]="'/assets/social/' + platform.key.toLowerCase() + '.png'" />
                    <span class="social-name">{{ platform.key }}</span>
                  </div>
                  <mat-slide-toggle
                    (change)="updatePlatforms(platform.key, $event.checked)"
                    [checked]="getSocialPlatforms().indexOf(platform.key) > -1"
                  ></mat-slide-toggle>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="dialog-bottom">
          <div class="row">
            <div class="ml-auto col-12 col-md-4">
              <button
                type="submit"
                class="btn btn-primary d-block w-100"
                [disabled]="formDraftPost.invalid || !selectedShops.length"
              >
                @if (!draftPostId) {
                  {{ 'global.confirm' | transloco }}
                } @else {
                  {{ 'global.update' | transloco }}
                }
              </button>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>
